import React, { FunctionComponent } from 'react';

import { SingleSegmentedControlStep } from 'scenes/common/components/Steps';
import { UNDER_1_TO_FIVE_PLUS_OPTIONS } from 'scenes/common/types';
import {
  getDriverAge,
  getDriverType,
  getYearsDriving,
} from 'scenes/motor/selectors';
import { MotorFullPageProps } from 'scenes/motor/types';

const MIN_AGE = 16;
const STATE_KEY = 'yearsDriving';
const HELP_TEXT = "Drivers holding a Learner Permit don't need to be added.";

const YearsDrivingStep: FunctionComponent<MotorFullPageProps> = ({
  flowType,
  funnelState,
  onNext,
}) => {
  const driverType = getDriverType(flowType);

  return (
    <SingleSegmentedControlStep
      onNext={onNext}
      question={`How many years has the ${driverType} driver held a licence?`}
      stateKey={STATE_KEY}
      helpText={HELP_TEXT}
      options={UNDER_1_TO_FIVE_PLUS_OPTIONS}
      defaultStateValue={getYearsDriving(funnelState)}
      validationRules={{
        validate: {
          oneOf: (value: number) =>
            UNDER_1_TO_FIVE_PLUS_OPTIONS.some(
              (option) => option.value === value
            ),
          soon: (value: number) =>
            getDriverAge(funnelState) - value >= MIN_AGE ||
            "The number of years licenced exceeds the maximum possible based on the driver's age",
        },
      }}
    />
  );
};

export default YearsDrivingStep;
